import { Reveal } from "../components/Reveal";
import { MANIFESTO } from "../data/content";

export default function ManifestoSection() {
  return (
    <section className="bg-[#0a0a0a] text-white" data-testid="manifesto-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36">
        <Reveal><p className="text-sm text-neutral-500 mb-8">{MANIFESTO.eyebrow}</p></Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display text-4xl md:text-7xl tracking-tighter font-medium leading-[0.95] max-w-4xl">
            {MANIFESTO.heading}
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-8 text-lg md:text-xl text-neutral-400 leading-relaxed max-w-2xl">{MANIFESTO.lead}</p>
        </Reveal>
        <div className="mt-16 md:mt-24 border-t border-white/10">
          {MANIFESTO.tenets.map((t, i) => (
            <Reveal key={t.verb} delay={i * 0.08}>
              <div className="grid md:grid-cols-12 gap-3 md:gap-10 items-baseline py-8 md:py-10 border-b border-white/10">
                <h3 className="md:col-span-4 font-display text-3xl md:text-5xl tracking-tighter font-medium">{t.verb}</h3>
                <p className="md:col-span-7 md:col-start-6 text-lg md:text-xl text-neutral-400 leading-relaxed">{t.line}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
